import { render, staticRenderFns } from "./EditUserImg.vue?vue&type=template&id=9c79a232&scoped=true"
import script from "./EditUserImg.vue?vue&type=script&lang=js"
export * from "./EditUserImg.vue?vue&type=script&lang=js"
import style0 from "./EditUserImg.vue?vue&type=style&index=0&id=9c79a232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c79a232",
  null
  
)

export default component.exports